<template>
  <div
    :class="[pulseClasses]"
    class="bg-skeleton h-twentyFive w-twentyFive rounded"
    aria-hidden="true"
    data-test="checkbox"
  >
  </div>
</template>

<script>
export default {
  name: 'SkeletonCheckbox',
  props: {
    /**
     * When pulse is true and used within another skeleton
     * component, the pulsing increases.
     *
     * If this component is used on its own somewhere, it won't
     * pulse unless this is true.
     */
    pulse: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    pulseClasses() {
      return {
        'animate-pulse': this.pulse,
      };
    },
  },
};
</script>
